
import React from 'react';
import {css} from 'emotion';

export const FormEditBlockFieldReverseValue = function (props) {

  if (props.block()?.component != 'OpinionScaleInput')
    return (<></>);

  return (<>
    <label
      className={css`
        display: flex;
        gap: 8px;
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      <div
        className={css`
          display: grid;
          place-content: center;
          place-items: center;
        `}
      >
        <input
          type="checkbox"
          checked={props.block()?.props?.reverseValue ?? false}
          onChange={(e) => {
            props.block({
              ...props.block(),
              props: {
                ...props.block()?.props,
                reverseValue: !(props.block()?.props?.reverseValue ?? false),
              },
            });
          }}
        />
      </div>
      <div
        className={css`
          display: grid;
          place-content: center;
          place-items: center;
        `}
      >
        Reverse Value
      </div>
    </label>
  </>);

};
